import { isChunkLoadError, pendingForever, reloadForStaleChunk } from '~/lib/stale-chunk'

/**
 * `lazy` helper for default-exported page modules (each page becomes its own chunk). A chunk that is gone after a
 * redeploy triggers one guarded full reload; if that does not help, the error reaches `RouteError`.
 */
export const page = (load: () => Promise<{ default: React.ComponentType }>) => async () => {
  try {
    return { Component: (await load()).default }
  } catch (err) {
    if (isChunkLoadError(err) && reloadForStaleChunk()) return pendingForever<{ Component: React.ComponentType }>()
    throw err
  }
}
